import { useEffect, useRef, useState } from "react"

import { CasePicker, caseLine } from "@/components/CasePicker"
import { Button } from "@/components/ui/button"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { dash } from "@/lib/utils"
import { labelOf } from "@shared/ny"
import type { AdjudicateStreamEvent, Authority, NyCase, Verdict } from "@shared/types"

const CHERUB = String.raw`                             .    --=+*+--.  -*+
                             .      .:-+#%+:+@@#*@@%@#%+-*#: .
                              .    .+##*@@%%#@%%@%#%*#+*%#*%%#@*..
                         .  .  :-=+#***%@%%@%%@@@##@%%#*%%%%%*@*=#- . ..
                            -=#@@@@%#%*#%%%@@@@##%@@%@%#@#@**%@*#@%+=:..
                           =@@@@%%%@#%%#**###@@%#-+##+*%@*%#*%%#+-*##*-.
                          -#%@#%#*@@#=-:  =#%%*#- :%+.%@#*==###@@- +*##-    .
                          +@#%@###%=-:.  -#*@*.-   :  +%#@+ :: =%+:+*%=:
                          -##%%##*= .-:..+@%%+.*-  ...-%##%%.-=. . :#%**:.
                           +@%#%%###@%-+#@@%#+-%= *=-#+*#*%%==@#:*- -*%%-.  .
                           :%%@@@%%@*######@%#*%*+@%*%@#@%%%%#%%*##+:+%#=.
                            -%@@@%%@@@@@%%#*#%*#%**#%%%#%%%@@@###@#++%@##-
                            -%@%#+**%#*@@%@@%#%@@@%%#+**%%+%%#%*#%++@@#%#:     =-
                         . =##%%#=+**-*%@%=:#%#***%#+##%%%@%#%#**#%#+#%%*@*.:=*#:
                         -+#@@#*%++#+-+*@%===*+-=.=-.:+##%@%+#*++%@%%@@%##%++#+.
                        .-  =#%##*%%=*#+#@##:###@=+##*=+*%@@%%=%@@#%##@@@*=*-:..:.
                        .-:++=#%*%@#*+#@%#=%%++*@##@#*#%#*%@*++@@%%+:+%%%#*+=-:.
                           . .+#%#%%+*#@%%%%@@++**##+*+=*#*++++-++***#*%%#-  . .
                             .####@*:*#%@%%%#@@@@@%*##*+-=+=*+%##*##+%#++-:.
                             .*@%%@%*##@###%#@%*#%@#++*##%%*#%@@*#@###=   .. --+.
                .    .      .:+#@@%@%#%@%@@%@@##*@#++#%##%#@@@@%%@##+  ..   :=-=
    .-++=-..-=:..:   .    .. -#*@%%#**#%@%*#%*#++%@@%%%@%%#%@#%#@@%#.  .:==--:=:
       :==+-*%#*+-=+-=+=..   .=++*#%##%##**@##*#%%%@##%%#@%%%*%%@@+::-+=++**---
        :*#*+*=+*###*+#*#@*--. .:+#*@%#++***#@%*#++%##@%#@###%@#*#*%%+*+#-*%+=:
        :=#@@%##*%#==+==*#**++=...:=%#%%*#*++#*++*#%*@@@*@%##++++*++%*%##*#%#+
         .-#@%%%#**#=#%#*#+**##@*- :-:+#@@@%#%%#@#%@@@@%%#+--*%#-+#%#++-*@#%%-     .
         .+=%%#####+=*#%###*++*###+-   .-*@%*%%*@@@%*=++  -*%%#++*#*#=:+%*%+-      . .  ..
          --=++#@@%%*+=+#*#%##+*%%#*@*::.=@#####=+---=+==%%%#*%%#%*+*.+#@##- .   .      ..
            -+++%%##+@%:*#@@#**#%*%#***%*@%*@##@@#*%%%%#%@%%*+%%*+--+#*=%#.        . .--:
          ..  :+*#%%#@@*=--*@##%%@%%**@@@###%#*#@@#@%####+%%*@@%#*++**#-.....       :+-::
               ..*#*%#@#%%+++###*@@@%%@@#*#%#*@@#**##**++*%####%@##=#+-.             :+%=
    :-           .::-%%##%@@+%@%#@#+####+##@#+@@+#%%@%**#%%@@=++-+= .:  :      .    :++:.-
==- *#.   .        . --:**###*#%**@==###**##*%+=%%%@@@@##*%**=%#-        .    .   :++:   .
#*+*%#=:: :=-:++ :==--:.::==+-=-=#%**++####=+#**#*%#*#*#@##%--%###-..  ...    ..:+%-...
  .-*#%+      :.    ..  ....:-: :--+#*%%@%#%@%#*#%**##+@%*%%#%%###%+=-=--:::.-=::*%=#%@%:
     -+%+                  .       =##@@***@@**#*+*%%**#%@%##%#+#+#@=:     =+=. -*#*+=@@+
       +%=                        .=*@%##*###*+#%%#*%*+#%%###+%*+%%%%=:  :=+. .+##*.  :..
     ...+#-           .            :%@#*%**%#+++%#+#%###*%%%%%@= :-+%%%*++:  .+%#:
    ..   =#=                        +%@%%@*@%%@%%**@##%%=#%@#%+:.   +@%%%: :**+-:  .    .
         .+%*..                     -#**+%+*%*#%%#%%%%##%*#*+%-  ..::=-:-=##*:     .
           :#+:    .                :%##*%+##%#%@%%@#*@#%%%%+:  .=-:.  +%@#=        .
            :+@%-  .   ..           .#%#@%=*#%*#%@@*#%@#%@#-:*=--:.:=*##+-  .  .
              -=*#=.   ..            =%+##*=*%%*+##%@@%*+==*#%-::=***+-
                .=#+=+:              -##%%%@+-=+##%%%*#= +#%+-=+%#=-:      .
             . .   .=**++=:---===-+%-=%#*##+*++#@@@#%%#+==###+-=-            .
             .   .     .--+**++=--..  -+++*-=+#+%%#%%*###+++:
                                        .   .*@###+++*+=***+    ..  .
                                           :.+#*%@@#*#=%@##= .
                                             =##@@%%#+*@@%+.
                                            .+*#@@@#=#@%#=
                                          . .=+%@%@+:%@*: .
                                             .%%*@%+-**:
                                              +#*#+:+*#%+-.
                                              :*#@#:++-+#+*:
                                               -#@#. .    ..
                                              -#@@@*        .
                                             .=*%##+  .     .`

const RULE = String.raw`_____ ___________ ____ ______________`

function EmptyState() {
  return (
    <div className="space-y-3 pt-6 pb-8 text-muted-foreground">
      <pre className="overflow-x-auto pl-8 text-[3px] leading-[3.6px]">{CHERUB}</pre>
      <pre className="overflow-x-auto text-sm leading-snug opacity-50">{RULE}</pre>
      <p className="text-sm">Beloved, do not believe every spirit.</p>
    </div>
  )
}

// The model's names (misapplied / contrary) state the test it has to apply;
// these are what the reader sees.
const KIND: Record<Authority["kind"], { label: string; hint: string }> = {
  misapplied: {
    label: "cited",
    hint: "Cited in the decision, but applied incorrectly",
  },
  contrary: {
    label: "not cited",
    hint: "Never cited in the decision — new authority that cuts against it",
  },
}

// Green is good news, red is bad — and for reversal "good" runs the other way.
const scale = (pct: number, highIsGood: boolean) => {
  const good = highIsGood ? pct >= 70 : pct <= 30
  const bad = highIsGood ? pct < 45 : pct > 60
  if (good) return "text-emerald-600 dark:text-emerald-400"
  if (bad) return "text-red-600 dark:text-red-400"
  return "text-amber-600 dark:text-amber-400"
}

function Meter({ label, pct, highIsGood }: { label: string; pct: number; highIsGood: boolean }) {
  return (
    <div className="space-y-1">
      <div className="flex items-baseline justify-between gap-4">
        <span className="text-sm text-muted-foreground">{label}</span>
        <span className={`text-lg font-semibold ${scale(pct, highIsGood)}`}>{pct}%</span>
      </div>
      <div className="h-1.5 w-full bg-muted">
        <div
          className="h-full bg-foreground transition-[width] duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}

function useAdjudication() {
  const [picked, setPicked] = useState<NyCase>()
  const [steps, setSteps] = useState<string[]>([])
  const [authorities, setAuthorities] = useState<Authority[]>([])
  const [verdict, setVerdict] = useState<Verdict>()
  const [err, setErr] = useState<string>()
  const [running, setRunning] = useState(false)
  const esRef = useRef<EventSource | null>(null)

  const reset = () => {
    esRef.current?.close()
    esRef.current = null
    setPicked(undefined)
    setSteps([])
    setAuthorities([])
    setVerdict(undefined)
    setErr(undefined)
    setRunning(false)
  }

  const start = (c: NyCase) => {
    reset()
    setPicked(c)
    setRunning(true)
    const es = new EventSource(`/api/adjudicate?id=${encodeURIComponent(c.id)}`)
    esRef.current = es
    const finish = () => {
      setRunning(false)
      es.close()
    }
    es.onmessage = (e) => {
      let ev: AdjudicateStreamEvent
      try {
        ev = JSON.parse(e.data) as AdjudicateStreamEvent
      } catch {
        return
      }
      if (ev.type === "step") setSteps((s) => [...s, ev.text])
      else if (ev.type === "authority") setAuthorities((a) => [...a, ev.authority])
      else if (ev.type === "verdict") setVerdict(ev.verdict)
      else if (ev.type === "error") {
        setErr(ev.text)
        finish()
      } else if (ev.type === "done") finish()
    }
    es.onerror = finish
  }

  useEffect(() => () => esRef.current?.close(), [])

  return { picked, steps, authorities, verdict, err, running, start, reset }
}

function AuthorityTable({ rows }: { rows: Authority[] }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[17rem]">Authority</TableHead>
          <TableHead>Explanation</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((a, i) => (
          <TableRow key={`${a.corpus}|${a.cite}|${i}`} className="animate-in fade-in duration-500">
            <TableCell className="align-top whitespace-normal">
              <span className="block font-medium">{dash(a.cite)}</span>
              <span className="block text-xs text-muted-foreground">{a.heading}</span>
              <span
                className="mt-1 inline-block bg-primary/10 px-1.5 py-0.5 text-xs text-primary"
                title={KIND[a.kind]?.hint}
              >
                {KIND[a.kind]?.label ?? a.kind}
              </span>
            </TableCell>
            <TableCell className="align-top whitespace-normal text-muted-foreground">
              {a.why}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export function AdjudicateTab() {
  const run = useAdjudication()
  const { picked, steps, authorities, verdict, err, running } = run

  if (!picked)
    return (
      <div className="space-y-4">
        <CasePicker onPick={run.start} />
        <EmptyState />
      </div>
    )

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 border-b pb-3">
        <div className="min-w-0">
          <a
            href={`/cases/${picked.id}`}
            className="block truncate font-medium text-inherit"
            title={picked.name ?? undefined}
          >
            {dash(picked.name)}
          </a>
          <span className="block text-xs text-muted-foreground">
            {[caseLine(picked), picked.subjectArea && labelOf(picked.subjectArea)]
              .filter(Boolean)
              .join(" · ")}
          </span>
          {picked.summary && (
            <span className="block text-xs text-muted-foreground">{picked.summary}</span>
          )}
        </div>
        <div className="flex shrink-0 gap-2">
          {!running && (
            <Button variant="outline" size="sm" onClick={() => run.start(picked)}>
              Re-run
            </Button>
          )}
          <Button variant="ghost" size="sm" onClick={run.reset}>
            Change case
          </Button>
        </div>
      </div>

      {(steps.length > 0 || running) && (
        <ol className="space-y-1 border bg-muted/30 p-3 text-xs text-muted-foreground">
          {steps.map((s, i) => (
            <li key={i}>{s}</li>
          ))}
          {running && <li className="animate-pulse text-foreground">Cooking…</li>}
        </ol>
      )}

      {verdict && <Meter label="Correctness" pct={verdict.correctness} highIsGood />}

      {authorities.length > 0 ? (
        <AuthorityTable rows={authorities} />
      ) : (
        !running &&
        verdict && (
          <p className="text-sm text-muted-foreground">
            No authority found that undercuts this decision.
          </p>
        )
      )}

      {verdict && (
        <div className="space-y-3 border-t pt-3">
          <p className="text-sm">
            Potential for reversal:{" "}
            <span className={`font-semibold ${scale(verdict.reversal, false)}`}>
              {verdict.reversal}%
            </span>
          </p>
          <p className="text-sm text-muted-foreground">{verdict.summary}</p>
        </div>
      )}

      {err && <p className="text-sm text-red-600">{err}</p>}
    </div>
  )
}
